import * as Actions from './auth.actions';
import { EMPTY_PROFILE, Profile } from '../../services/profile.model';
import { AuthConstants } from '@app/constants/application-constants';
import { AuthService } from '@app/services/auth.service';
import { error } from 'protractor';
import { AuthToken } from '@app/model/auth/auth-token.model';

const profileFromLocalStorage = AuthService.getProfileFromLocalStorage();
const authTokenFromLocalStorage = AuthService.getAuthTokenFromLocalStorage();

export interface State {
    authToken: AuthToken;
    loggedIn: boolean;
    profile: Profile;
    loginError?: string;
}

const initialState = {
    authToken: authTokenFromLocalStorage ? authTokenFromLocalStorage : null,
    loggedIn: false,
    profile: profileFromLocalStorage ? profileFromLocalStorage : EMPTY_PROFILE
};

export function AuthReducer(state = initialState, action: Actions.AuthActions) {

    switch (action.type) {
    case Actions.SET_AUTH_TOKEN:
        return {
            ...state,
            authToken: action.authToken
        };
    case Actions.EXISTING_LOGIN_FOUND:
        return {
            ...state,
            loggedIn: true
        };
    case Actions.SET_LOGGED_IN:
        return {
            ...state,
            loggedIn: action.loggedIn
        };
    case Actions.SET_USER_PROFILE:
        return {
            ...state,
            profile: action.profile
        };
    case Actions.CLEAR_ALL_AUTH_DATA:
        return {
            ...state,
            profile: EMPTY_PROFILE,
            authToken: null,
            loggedIn: false,
        };
    case Actions.CLEAR_USER_PROFILE:
        return {
            ...state,
            profile: EMPTY_PROFILE
        };
    case Actions.USER_INFO_LOADED:
        return {
            ...state,
            profile: action.profile
        };
    case Actions.SET_LOGIN_ERROR:
        return {
            ...state,
            loginError: action.error
        };
    case Actions.CLEAR_LOGIN_ERROR:
        return {
            ...state,
            loginError: null
        };
    default:
        return state;
    }
}

// selectors
export const getAuthToken = (state: State) => state.authToken;
export const getLoggedIn = (state: State) => state.loggedIn;
export const getLoggedOut = (state: State) => !state.loggedIn;
export const getProfile = (state: State) => state.profile;
export const getLoginError = (state: State) => state.loginError;
